import { Radio } from 'antd'
import { Dispatch, FC, SetStateAction, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { AssignationValues } from '../../types'
import { FlexRow, StyledLabels } from '../StyledComponents'

interface Props {
  assignation: AssignationValues
  isTripCfr: boolean
  beforeToday?: boolean
  setAssignValue: Dispatch<SetStateAction<AssignationValues | undefined>>
  assignValue?: AssignationValues
  disabled?: boolean
}

const AssignationRadioButton: FC<Props> = ({
  assignation,
  isTripCfr,
  beforeToday,
  setAssignValue,
  assignValue,
  disabled: propDisabled,
}) => {
  const { t } = useTranslation()
  const disabled = useMemo(
    () => propDisabled || isTripCfr || (assignation === 'automatic' ? beforeToday : undefined),
    [isTripCfr, assignation, beforeToday, propDisabled],
  )

  return (
    <FlexRow className="ticket-form__assign-radio-input">
      <Radio
        value={assignation}
        disabled={disabled}
        onChange={() => !isTripCfr && setAssignValue(assignation as 'automatic' | 'manual')}
        checked={isTripCfr ? assignation === 'manual' : assignValue === assignation}
      />
      <StyledLabels>{t(`globals.generics.${assignation}`)}</StyledLabels>
    </FlexRow>
  )
}

export default AssignationRadioButton
